import { render, staticRenderFns } from "./UserActionsFour.vue?vue&type=template&id=200673f5&scoped=true"
import script from "./UserActionsFour.vue?vue&type=script&lang=js"
export * from "./UserActionsFour.vue?vue&type=script&lang=js"
import style0 from "./UserActionsFour.vue?vue&type=style&index=0&id=200673f5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200673f5",
  null
  
)

export default component.exports